import React from 'react';
import styles from '../NewNG.module.css';

interface LiveIndicatorProps {
  textOnly?: boolean;
}

export const LiveIndicator: React.FC<LiveIndicatorProps> = ({ textOnly = false }) => {
  return (
    <>
      {/* Live indicator bar - only show if not text-only mode */}
      {!textOnly && <div className={styles['newng-live-indicator-video']}></div>}
      {/* Live text */}
      <div className={styles['newng-live-text']}>LIVE</div>
    </>
  );
};